var file_upload_viewer_default = {
  "fontElementMap": "KUgY4",
  "file_upload_container": "ThZfO",
  "file_upload_link": "xIEqs",
  "file_upload_error_container": "_2egeq",
  "file_upload_file_info": "sn0fL",
  "file_upload_type_icon": "kbfrN",
  "file_upload_status_icon_container": "RDAdh",
  "file_upload_status_icon": "UVfv6",
  "file_upload_description": "JXKgi",
  "file_upload_name_container": "eXX6K",
  "file_upload_name": "gndXb",
  "file_upload_extension": "sgqTw",
  "file_loader_icon": "KQ0SM",
  "file_upload_icon_frame": "iEKzd",
  "file_upload_icon_background": "dE9Ug"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
